import { Component, Input, OnInit } from '@angular/core';
import { ClientDoctorModel } from 'src/app/model/http/clientDoctorModel';
import { UpdateShoppingCartModel } from 'src/app/model/local/updateShoppingCartModel';
import {CommonService} from '../../services/common.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {ObservableService} from '../../services/observable.service';

@Component({
  selector: 'app-client-header',
  templateUrl: './client-header.component.html',
  styleUrls: ['./client-header.component.scss']
})
export class ClientHeaderComponent implements OnInit {
  @Input() clientDoctorModel = new ClientDoctorModel();
  constructor(
              private commonService: CommonService,
              private localStorageService: LocalStorageService,
              private observableService: ObservableService) { }

  ngOnInit(): void {
    this.clientDoctorModel.initialsName = this.commonService.getInitialsName(this.clientDoctorModel.name);
    this.reloadShoppingCart();
  }

  reloadShoppingCart(): void {
    const cart = new UpdateShoppingCartModel();
    cart.cartType = this.commonService.getCardTypeForRolShoppingCard(this.localStorageService.getUserInRole());
    cart.cardCode = this.localStorageService.getCardCodeGeneral();
    this.observableService.setUpdateShoppingCart(cart);
  }

}
